import {storageUtil} from '@px/helper/storage';

interface SpotSymbolStorage extends StorageObject {
  timeInForce: string;
}

const STORAGE_KEY_PREFIX = 'spot_symbol_cache_';

export const spotSymbolStorage = {
  readSpotSymbolStorage(symbol: string): SpotSymbolStorage {
    return storageUtil.readStorageObject(STORAGE_KEY_PREFIX + symbol, createInitSpotSymbolStorage());
  },

  updateSpotSymbolStorage(symbol: string, kv) {
    storageUtil.writeStorageObject(STORAGE_KEY_PREFIX + symbol, {...spotSymbolStorage.readSpotSymbolStorage(symbol), ...kv});
  },
};

function createInitSpotSymbolStorage(): SpotSymbolStorage {
  return {
    version: 1,
    symbol: '',
    timeInForce: 'GoodTillCancel',
  };
}
